// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if ({ "index":1,"vendors-node_modules_casl_ability_dist_es6c_index_js-node_modules_mui_icons-material_esm_Acco-60ac0b":1 }[chunkId]) return "static/css/" + chunkId + ".css";
  // return url for filenames based on template
  return "static/css/async/" + chunkId + ".css"
}